export const getBmi = (weight: number, height: number): number => {
    const adjustedHeight = height / 100;
    return weight / (adjustedHeight * adjustedHeight);
};
